// Registry of scheduling strategies. Add a new strategy by appending a definition here.
import type { SchedulingStrategyDefinition } from '../types'
import { helpKey } from '../../help'
import {
  ActionModuleFrequency,
  DayOfWeek,
  ScheduleDefinitionType,
  SchedulingStrategyType,
  type RepeatPatternSchedulingStrategyModel,
  type ScheduleDaysDefinition,
} from './types'
import RepeatPatternEditor from '@/pages/action-modules/editor/scheduling-tab/strategies/RepeatPatternEditor'
import ScheduleDefinitionStrategyEditor from '@/pages/action-modules/editor/scheduling-tab/strategies/ScheduleDefinitionStrategyEditor'

export const schedulingStrategies: SchedulingStrategyDefinition[] = [
  {
    nameKey: 'schedulingStrategy.repeatPattern.name',
    helpKey: helpKey('schedulingRepeatPattern'),
    type: SchedulingStrategyType.RepeatPatternSchedulingStrategy,
    defaultValue: {
      frequency: ActionModuleFrequency.Weekly,
    } as RepeatPatternSchedulingStrategyModel,
    editor: props => <RepeatPatternEditor {...props} />,
  },
  {
    nameKey: 'schedulingStrategy.scheduleDefinition.name',
    helpKey: helpKey('schedulingScheduleDefinition'),
    type: SchedulingStrategyType.ScheduleDefinitionSchedulingStrategy,
    defaultValue: {
      scheduleDefinition: {
        combineConsecutiveDays: false,
        discriminator: ScheduleDefinitionType.Day,
        startDate: null,
        endDate: null,
        separateByMonth: false,
        separateByWeek: false,
        days: [DayOfWeek.Monday, DayOfWeek.Tuesday, DayOfWeek.Wednesday, DayOfWeek.Thursday, DayOfWeek.Friday].map(
          dayOfWeek => ({ dayOfWeek, startTime: null, endTime: null }),
        ),
      } as ScheduleDaysDefinition,
    },
    editor: props => <ScheduleDefinitionStrategyEditor {...props} />,
  },
  {
    nameKey: 'schedulingStrategy.afterEmployeeCreation.name',
    helpKey: helpKey('schedulingAfterEmployeeCreation'),
    type: SchedulingStrategyType.AfterEmployeeCreationSchedulingStrategy,
    defaultValue: {},
    // Nothing to configure — the scheduling tab renders `helpKey` on its own.
    editor: () => null,
  },
  {
    nameKey: 'schedulingStrategy.definedBySubtype.name',
    helpKey: helpKey('schedulingDefinedBySubtype'),
    type: SchedulingStrategyType.DefinedBySubtypeSchedulingStrategy,
    defaultValue: {},
    editor: () => null,
  },
]
